import React from 'react';

export function Breadcrumb({ items }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)', fontFamily: 'var(--font-body)' }}>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span style={{ opacity: .5 }}>›</span>}
          <span style={{ color: i === items.length - 1 ? 'var(--text-1)' : 'var(--text-muted)', fontWeight: i === items.length - 1 ? 500 : 400 }}>{item}</span>
        </React.Fragment>
      ))}
    </div>
  );
}
